// extracted by mini-css-extract-plugin
export default {"authentication-card":"AuthenticationCard_authentication-card__ivONv"};